import Image from "@/components/AppImage";
import Link from "@/components/AppLink";
import app_download_screen from "/public/img/app-download-screen.png";
import apple_btn from "/public/img/apple_btn.png";
import check_alt from "/public/img/check-alt.png";
import gPlay_btn from "/public/img/gPlay_btn.png";

const DEFAULT_BULLETS = [
  "Approve incoming transfers and release payouts on the go",
  "Live status for every cross-border invoice you send",
  "Repeat payouts to the same clients in one tap",
];

interface AppDownloadProps {
  title?: string;
  intro?: string | null;
  bullets?: string[];
}

const AppDownload = ({
  title = "Track global payouts from your phone",
  intro = null,
  bullets = DEFAULT_BULLETS,
}: AppDownloadProps) => {
  return (
    <section className="app-download inner-app-download">
      <div className="overlay pt-120 pb-120">
        <div className="container cus-mar">
          <div className="row">
            <div className="col-lg-6">
              <div className="img-area wow fadeInUp">
                <Image src={app_download_screen} alt="image" />
              </div>
            </div>
            <div className="col-lg-6 col-md-8 d-flex align-items-center">
              <div className="right-area">
                <div className="section-header">
                  <h2 className="title">{title}</h2>
                  {intro ? <p>{intro}</p> : null}
                </div>
                <ul className="feature">
                  {bullets.map((text, i) => (
                    <li key={i}>
                      <div className="icon">
                        <Image src={check_alt} alt="icon" />
                      </div>
                      {text}
                    </li>
                  ))}
                </ul>
                <div className="app-market">
                  <Link href="#">
                    <Image src={gPlay_btn} alt="App Store" />
                  </Link>
                  <Link href="#">
                    <Image src={apple_btn} alt="App Store" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppDownload;
